import React, { useState } from "react";
import {
  Box,
  List,
  Divider,
  Button,
  Typography,
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Chip,
} from "@mui/material";
import NestedListExpandIcon from "./NestedListExpandIcon";

const VendorFilters = ({ vendors, selectedVendors, toggleVendorTarget, clearVendors }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const selectedCount = Object.keys(selectedVendors).length;

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    clearVendors();
  };

  return (
    <>
      <Box
        sx={{
          marginTop: 4,
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[300],
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          borderBottomLeftRadius: isExpanded ? 0 : 8,
          borderBottomRightRadius: isExpanded ? 0 : 8,
        }}
      >
        <Box
          onClick={handleToggleExpanded}
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: 2,
            backgroundColor: (theme) => theme.palette.terrain[100],
            borderTopLeftRadius: 7,
            borderTopRightRadius: 7,
            cursor: "pointer",
          }}
        >
          <Typography variant="body2">Vendors</Typography>
          <Box sx={{ flexGrow: 1 }} />
          {selectedCount > 0 ? (
            <Chip
              size="small"
              label={selectedCount}
              color="primary"
              sx={{
                marginRight: 2,
                borderRadius: 10,
                "& .MuiChip-label": { paddingLeft: 2.5, paddingRight: 2.5 },
              }}
            />
          ) : null}
          <Button
            variant="outlined"
            sx={{ marginRight: 2 }}
            onClick={handleClear}
          >
            <Typography variant="body1">Clear</Typography>{" "}
          </Button>
          <NestedListExpandIcon
            isOpen={isExpanded}
            toggleOpen={handleToggleExpanded}
          />
        </Box>
        <Collapse in={isExpanded} timeout="auto">
          <List
            disablePadding
            sx={{
              overflow: "scroll",
              maxHeight: { xs: "200px", md: "300px" },
              borderTop: "1px solid",
              borderColor: (theme) => theme.palette.terrain[300],
            }}
          >
            {vendors.length === 0 ? (
              <Box sx={{ padding: 2 }}>
                <Typography variant="body1">
                  No vendors found in your establishment
                </Typography>
              </Box>
            ) : null}
            {vendors.map((vendor) => (
              <ListItemButton
                disableRipple
                disableTouchRipple
                key={vendor.id}
                sx={{
                  borderLeft: (theme) =>
                    `2px solid ${theme.palette.primary[100]}`,
                  margin: 0,
                  padding: 0,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%",
                    borderBottom: "1px solid",
                    borderBottomColor: (theme) => theme.palette.terrain[300],
                    padding: 1,
                  }}
                >
                  <ListItemIcon>
                    <Checkbox
                      id={vendor.id}
                      checked={selectedVendors[vendor.id] !== undefined}
                      onChange={() => toggleVendorTarget(vendor.id)}
                      sx={{ color: (theme) => theme.palette.primary[800] }}
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ marginLeft: -2 }}>
                    <div
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography variant="body1" noWrap>
                        {vendor.name}
                      </Typography>
                    </div>
                  </ListItemText>
                </Box>
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      </Box>
      <Divider sx={{ marginLeft: -8, marginRight: -8 }} />
    </>
  );
};

export default VendorFilters;
